import React, { useState } from 'react';
import { BsChatLeftTextFill } from 'react-icons/bs';
import { Tooltip } from 'reactstrap';
import { twMerge } from 'tailwind-merge';

export type TooltipIconProps = {
    id: string;
    disabled?: boolean;
    description?: string;
    className?: string;
};

export const TooltipIcon = (props: TooltipIconProps) => {
    const { disabled, id, description, className } = props;

    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);

    return (
        <div className={className}>
            <div
                id={id}
                className={twMerge(
                    'flex h-full items-center justify-center p-2 relative text-[#317ddc]',
                    disabled && 'pointer-events-none opacity-50 text-black',
                )}
            >
                <BsChatLeftTextFill
                    size={20}
                    className="pointer-events-none"
                />
            </div>
            {!disabled && (
                <Tooltip
                    placement="top"
                    isOpen={tooltipOpen}
                    target={id}
                    toggle={toggle}
                    innerClassName="max-w-[600px] whitespace-pre-line"
                >
                    {description}
                </Tooltip>
            )}
        </div>
    );
};
